"use client"

import React, { useEffect } from 'react'

export default function Warpwe({children}) {
    useEffect(() => {
        scrollTo(0, 0);
      });
  return (
    <div>{children}</div>
  )
}
